<template>
  <VDialog
    ref="globalErrorDialog"
    v-model="isServerErrorDialogOpen"
    width="425"
    persistent
    outlined
    data-test="server-error-dialog"
  >
    <VCard>
      <VCardTitle class="pb-0">
        <span class="heading-6" data-test="server-error-title">
            {{ $t('checkout.serverErrorDialogTitle') }}
        </span>
      </VCardTitle>
      <VCardText class="pb-0">
        <div class="d-flex align-items-center justify-content-center py-6">
          <img
            :src="require('@slg/web-customer-shared/src/assets/img/sad-cat.svg')"
            :alt="$t('imageAlt.errorIllustration')"
            data-test="server-error-image"
          >
        </div>
        <div class="d-flex">
          <span class="body-1 textSecondary--text" data-test="server-error-message">
            {{ $t('checkout.serverErrorDialog') }}
          </span>
        </div>
      </VCardText>
      <VCardActions class="pb-4 pt-6">
        <VBtn
          class="w-100 shadow-none"
          color="brandingPrimary"
          dark
          data-test="server-error-ok-button"
          @click="$emit('closeDialog')"
        >
          <span class="button">
            {{ $t('general.ok') }}
          </span>
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script lang="ts">
export default {
  name: 'SServerErrorDialog',
};
</script>

<script setup lang="ts">
defineProps({
  isServerErrorDialogOpen: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['trackGtmEventServerErrorOccurred', 'closeDialog']);

function closeDialog() {
  emit('trackGtmEventServerErrorOccurred');
  emit('closeDialog');
}
</script>

<style scoped lang="scss">

</style>
